import { ELiveClassHistoryDrawerTab } from '@constants';
import { ILiveClassStat } from '@sdk/contracts';
import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  event?: ILiveClassStat;
  activeTab: ELiveClassHistoryDrawerTab;
  open: (event: ILiveClassStat, tab: ELiveClassHistoryDrawerTab) => void;
  setTab: (tab: ELiveClassHistoryDrawerTab) => void;
  close: () => void;
}

export const useLiveClassDrawer = createStore<IStore>(set => ({
  isOpen: false,
  event: undefined,
  activeTab: ELiveClassHistoryDrawerTab.DETAIL,
  open: (event: ILiveClassStat, tab: ELiveClassHistoryDrawerTab) =>
    set({ isOpen: true, event, activeTab: tab }),
  setTab: (tab: ELiveClassHistoryDrawerTab) => set({ activeTab: tab }),
  close: () =>
    set({ isOpen: false, event: undefined, activeTab: ELiveClassHistoryDrawerTab.DETAIL })
}));
